export default __webpack_public_path__ + "static/Plots0115-08524c276f5d7d83a0ecc4f5498f7cd9.jpg";